import { breadcrumbSlot } from "@redotech/redo-web/breadcrumb";
import { Navigate, RouteObject } from "react-router-dom";
import { BoxlessDropoffsPage } from "./team/boxless-dropoffs/boxless-dropoffs-page";
import { CustomerAccountsPage } from "./team/customer-accounts";
import { ImsPage } from "./team/ims";
import { ManagedReturnsPage } from "./team/managed-returns";
import { OrderTrackingPage } from "./team/orders";
import { OutboundLabelsPage } from "./team/outbound-labels";
import { ReturnsGeneralPage } from "./team/returns-package-protection/v2/general";
import { SupportPage } from "./team/support";
import { TnplPage } from "./team/tnpl";
import { WarrantiesPage } from "./team/warranties";
const teamBreadcrumb = breadcrumbSlot();

export const teamRoutes: RouteObject[] = [
  {
    handle: { breadcrumb: "Merchants" },
    async lazy() {
      const { Page } = await import("../app/page");
      return { Component: Page };
    },
    children: [
      {
        index: true,
        async lazy() {
          const { TeamsPage } = await import("./teams");
          return { Component: TeamsPage };
        },
      },
      {
        path: "create",
        handle: { breadcrumb: "Create Team" },
        async lazy() {
          const { CreateTeamPage } =
            await import("./create-team/create-comment-sold-team-page");
          return { Component: CreateTeamPage };
        },
      },
      {
        path: "create-3pl",
        handle: { breadcrumb: "Create 3PL" },
        async lazy() {
          const { Create3PLTeamPage } =
            await import("./create-team/create-3pl-page");
          return { Component: Create3PLTeamPage };
        },
      },
      {
        path: "create-custom",
        handle: { breadcrumb: "Create Custom Team" },
        async lazy() {
          const { CreateCustomTeamPage } =
            await import("./create-team/create-custom-team-page");
          return { Component: CreateCustomTeamPage };
        },
      },
      {
        handle: { breadcrumb: teamBreadcrumb },
        path: ":teamId",
        children: [
          { index: true, element: <Navigate replace to="general" /> },
          {
            path: "open",
            async lazy() {
              const { OpenMerchantAppPage } =
                await import("./open-merchant-app-page");
              return { element: <OpenMerchantAppPage /> };
            },
          },
          {
            path: "",
            async lazy() {
              const { TeamPage } = await import("./team");
              return { element: <TeamPage breadcrumb={teamBreadcrumb} /> };
            },
            children: [
              {
                path: "general",
                async lazy() {
                  const { TeamPage } = await import("./team/general");
                  return { Component: TeamPage };
                },
              },
              {
                path: "products",
                async lazy() {
                  const { ProductsPage } =
                    await import("./team/products/products-page");
                  return { Component: ProductsPage };
                },
              },
              {
                path: "users",
                async lazy() {
                  const { UsersPage } = await import("./team/users");
                  return { Component: UsersPage };
                },
              },
              {
                path: "analytics",
                async lazy() {
                  const { AnalyticsPage } = await import("./team/analytics");
                  return { Component: AnalyticsPage };
                },
              },
              {
                path: "aeo",
                async lazy() {
                  const { AeoPage } = await import("./team/aeo");
                  return { Component: AeoPage };
                },
              },
              {
                path: "disputes",
                async lazy() {
                  const { DisputesPage } = await import("./team/disputes");
                  return { Component: DisputesPage };
                },
              },
              {
                path: "messaging",
                async lazy() {
                  const { MessagingPage } = await import("./team/messaging");
                  return { Component: MessagingPage };
                },
              },
              {
                path: "shopper-agent",
                async lazy() {
                  const { ShopperAgentPage } =
                    await import("./team/shopper-agent");
                  return { Component: ShopperAgentPage };
                },
              },
              {
                path: "customer-support",
                async lazy() {
                  return { Component: SupportPage };
                },
              },
              {
                path: "orders",
                async lazy() {
                  return { Component: OrderTrackingPage };
                },
              },
              {
                path: "outbound-labels",
                async lazy() {
                  return { Component: OutboundLabelsPage };
                },
              },
              {
                path: "recognize",
                async lazy() {
                  const { RecognizePage } = await import("./team/recognize");
                  return { Component: RecognizePage };
                },
              },
              {
                path: "returns",
                children: [
                  { index: true, element: <Navigate replace to="general" /> },
                  {
                    path: "general",
                    async lazy() {
                      return { Component: ReturnsGeneralPage };
                    },
                  },
                  {
                    path: "return-protection",
                    async lazy() {
                      const { StandardReturnsProtectionPage } =
                        await import("./team/returns-package-protection/v2/standard-returns-protection-page");
                      return { Component: StandardReturnsProtectionPage };
                    },
                  },
                  {
                    path: "package-protection",
                    async lazy() {
                      const { PackageProtectionPage } =
                        await import("./team/returns-package-protection/v2/package-protection-page");
                      return { Component: PackageProtectionPage };
                    },
                  },
                  {
                    path: "fsr-protection",
                    async lazy() {
                      const { FinalSaleReturnsProtectionPage } =
                        await import("./team/returns-package-protection/v2/final-sale-returns-protection-page");
                      return { Component: FinalSaleReturnsProtectionPage };
                    },
                  },
                  {
                    path: "international-price-rounding",
                    async lazy() {
                      const { InternationalPriceRoundingPage } =
                        await import("./team/returns-package-protection/v2/international-price-rounding-page");
                      return { Component: InternationalPriceRoundingPage };
                    },
                  },
                  {
                    path: "widgets",
                    async lazy() {
                      const { CoveragePage } =
                        await import("./team/coverage/coverage");
                      return { Component: CoveragePage };
                    },
                  },
                  {
                    path: "toggle",
                    async lazy() {
                      const { testPage } =
                        await import("./team/returns-package-protection/v2/widget-pages/base-widget-page");
                      return { Component: testPage };
                    },
                  },
                  {
                    path: "pdp",
                    async lazy() {
                      const { PdpPage } =
                        await import("./team/returns-package-protection/v2/widget-pages/base-widget-page");
                      return { Component: PdpPage };
                    },
                  },
                  {
                    path: "product",
                    async lazy() {
                      const { ProductPage } =
                        await import("./team/returns-package-protection/v2/widget-pages/base-widget-page");
                      return { Component: ProductPage };
                    },
                  },
                  {
                    path: "cart-modifications",
                    async lazy() {
                      const { CartModificationsPage } =
                        await import("./team/returns-package-protection/v2/widget-pages/base-widget-page");
                      return { Component: CartModificationsPage };
                    },
                  },
                  {
                    path: "label-rate-overrides",
                    async lazy() {
                      const { LabelRateOverridesPage } =
                        await import("./team/returns-package-protection/v2/widget-pages/label-rate-overrides-page");
                      return { Component: LabelRateOverridesPage };
                    },
                  },
                ],
              },
              {
                path: "warranties",
                async lazy() {
                  return { Component: WarrantiesPage };
                },
              },
              {
                path: "customer-accounts",
                async lazy() {
                  return { Component: CustomerAccountsPage };
                },
              },
              {
                path: "ims",
                async lazy() {
                  return { Component: ImsPage };
                },
              },
              {
                path: "managed-returns",
                async lazy() {
                  return { Component: ManagedReturnsPage };
                },
              },
              {
                path: "recommerce",
                element: (
                  <Navigate relative="path" replace to="../managed-returns" />
                ),
              },
              {
                path: "marketing",
                async lazy() {
                  const { MarketingPage } = await import("./team/marketing");
                  return { Component: MarketingPage };
                },
              },
              {
                path: "conversion",
                children: [
                  {
                    index: true,
                    async lazy() {
                      const { ConversionPage } =
                        await import("./team/conversion");
                      return { Component: ConversionPage };
                    },
                  },
                  {
                    path: "onboarding",
                    async lazy() {
                      const { ConversionOnboardingPage } =
                        await import("./team/conversion/conversion-onboarding-page");
                      return { Component: ConversionOnboardingPage };
                    },
                  },
                ],
              },
              {
                path: "payments",
                async lazy() {
                  const { PaymentsPage } = await import("./team/payments");
                  return { Component: PaymentsPage };
                },
              },
              {
                path: "landed-cost",
                async lazy() {
                  const { LandedCostPage } = await import("./team/landed-cost");
                  return { Component: LandedCostPage };
                },
              },
              {
                path: "coverage",
                async lazy() {
                  const { CoveragePage } =
                    await import("./team/coverage/coverage");
                  return { Component: CoveragePage };
                },
              },
              {
                path: "tnpl",
                async lazy() {
                  return { Component: TnplPage };
                },
              },
              {
                path: "boxless-dropoffs",
                async lazy() {
                  return { Component: BoxlessDropoffsPage };
                },
              },
            ],
          },
          {
            handle: { breadcrumb: "A/B Tests" },
            path: "split",

            children: [
              {
                index: true,
                async lazy() {
                  const { SplitsPage } = await import("./split/split-tests");
                  return {
                    element: <SplitsPage breadcrumb={teamBreadcrumb} />,
                  };
                },
              },
              {
                path: ":splitId",
                async lazy() {
                  const { SplitPageResolver } =
                    await import("./split/split-details");
                  return { element: <SplitPageResolver newSplit={false} /> };
                },
              },
              {
                path: "create",
                async lazy() {
                  const { SplitPageResolver } =
                    await import("./split/split-details");
                  return { element: <SplitPageResolver newSplit /> };
                },
              },
              {
                path: "create/:splitId",
                async lazy() {
                  const { SplitPageResolver } =
                    await import("./split/split-details");
                  return { element: <SplitPageResolver newSplit /> };
                },
              },
            ],
          },
        ],
      },
    ],
  },
];
